/**
 * Converts degrees to radians.
 *
 * @param degrees
 */
export function degreesToRadians(degrees: number): number {
  return (Math.PI * degrees) / 180;
}
